import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_tenant_brand_settings: { message: "idle" },
};

export const update_tenant_brand_settings_Slice = createSlice({
 name: "update_tenant_brand_settings",
 initialState,
 reducers: {
  success_update_tenant_brand_settings: (state, action) => {
   state.update_tenant_brand_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_tenant_brand_settings: (state, action) => {
   state.update_tenant_brand_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_tenant_brand_settings: (state) => {
   state.update_tenant_brand_settings = { status: app_consts.IDLE };
  },
  loading_update_tenant_brand_settings: (state) => {
   state.update_tenant_brand_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_tenant_brand_settings, fail_update_tenant_brand_settings, reset_update_tenant_brand_settings, loading_update_tenant_brand_settings } = update_tenant_brand_settings_Slice.actions;

export default update_tenant_brand_settings_Slice.reducer;